import React from 'react';
import { Icon } from 'elements';

const Youtube = ({size, className}) => (
  <Icon size={size} className={className}>
    <path fill="#010002" d="M23.795,7.469c-0.134-1.598-1.086-3.612-3.044-3.684c-5.466-0.368-11.942-0.468-17.507,0
      c-1.727,0.194-2.91,2.297-3.039,3.894c-0.273,3.356-0.273,5.265,0,8.621c0.131,1.598,1.284,3.713,3.042,3.935
      c5.631,0.368,12.076,0.42,17.507,0c1.704-0.296,2.912-2.337,3.042-3.935C24.068,12.942,24.068,10.824,23.795,7.469z M8.998,16.246
      V7.643l7.5,4.302L8.998,16.246z"/>
  </Icon>
);

export default Youtube;



// WEBPACK FOOTER //
// ./src/core/icons/components/social/Youtube.jsx